import {FC, useEffect, useState} from 'react'
import {ICDRUser} from '../core/_models'
import {KTSVG} from '../../../template/helpers'
import {cdrAPI} from '../../../services/CDRService'
import clsx from 'clsx'
import {useParams} from 'react-router-dom'

type Props = {
  user: ICDRUser
  handleCancel: () => void
}

const CDRSettingsUserItem: FC<Props> = ({user, handleCancel}) => {
  const {appId} = useParams()
  const [userName, setUserName] = useState<string>(user.name)
  const [usersState, setUsersState] = useState<boolean>(false)
  const [userNumber, setUserNumber] = useState<string>(user.number)
  const [upsertUserIsError, setUpsertUserIsError] = useState<boolean>(false)
  const [upsertUser, {isLoading: isLoadingMutationUpsert}] = cdrAPI.useUpsertUserMutation()
  const [deleteUser, {isLoading: isLoadingMutationDelete}] = cdrAPI.useDeleteUserMutation()

  useEffect(() => {
    if (user.id === undefined) {
      setUsersState(true)
    }
  }, [user])

  const handleUpsertUser = () => {
    if (userNumber && userName) {
      const newUser: ICDRUser = {
        number: userNumber.trim(),
        name: userName.trim(),
      }
      if (user.id !== undefined) {
        newUser.id = user.id
      }
      upsertUser({app_id: appId!, user: [newUser]})
      setUsersState(false)
    } else {
      setUpsertUserIsError(true)
    }
  }

  const handleDeleteUser = () => {
    if (user.id !== undefined) {
      deleteUser({app_id: appId!, user_ids: [user.id!]})
    }
  }

  return (
    <>
      <tr role='row' className='text-gray-900 text-center'>
        {!usersState && (
          <>
            <td role='cell' className='min-w-150px p-2 px-0'>
              <div>{userNumber}</div>
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <div>{userName}</div>
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <button
                type='button'
                onClick={() => {
                  setUsersState(true)
                }}
                className='btn btn-icon btn-light-primary btn-sm me-1 align-self-center'
              >
                <KTSVG path='/media/icons/duotune/art/art005.svg' className='align-self-center' />
              </button>
            </td>
          </>
        )}
        {usersState && (
          <>
            <td role='cell' className='min-w-150px p-2 px-1'>
              <input
                name={`cdr-user-number-${user.id}`}
                className={clsx(
                  'form-control form-control-sm form-control-flush px-0 text-center bg-light-secondary rounded',
                  upsertUserIsError && userNumber === '' ? 'bg-light-danger' : 'bg-light-secondary'
                )}
                value={userNumber}
                onChange={(e) => {
                  setUserNumber(e.target.value)
                }}
              />
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <input
                name={`cdr-user-name-${user.id}`}
                className={clsx(
                  'form-control form-control-sm form-control-flush px-0 text-center bg-light-secondary rounded',
                  upsertUserIsError && userName === '' ? 'bg-light-danger' : 'bg-light-secondary'
                )}
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value)
                }}
              />
            </td>
            <td role='cell' className='min-w-200px p-2 px-0'>
              <button
                title='Save'
                className='btn btn-icon btn-light-success btn-active-color-light btn-sm me-1 align-self-center'
                onClick={handleUpsertUser}
                disabled={isLoadingMutationUpsert || isLoadingMutationDelete}
              >
                {!isLoadingMutationUpsert && (
                  <KTSVG path='/media/icons/duotune/general/gen037.svg' className='align-self-center' />
                )}
                {isLoadingMutationUpsert && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    <span className='spinner-border spinner-border-sm align-middle'></span>
                  </span>
                )}
              </button>
              <button
                className='btn btn-icon btn-light-primary btn-active-color-light btn-sm me-1 align-self-center'
                title='Cancel'
                onClick={() => {
                  setUserNumber(user.number)
                  setUserName(user.name)
                  setUsersState(false)
                  handleCancel()
                }}
              >
                <KTSVG path='/media/icons/duotune/general/gen034.svg' className='align-self-center' />
              </button>
              <button
                title='Delete'
                onClick={handleDeleteUser}
                className='btn btn-icon btn-light-danger btn-active-color-light btn-sm me-1 align-self-center'
              >
                {!isLoadingMutationDelete && (
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='align-self-center' />
                )}
              </button>
            </td>
          </>
        )}
      </tr>
    </>
  )
}

export {CDRSettingsUserItem}
